import { render, staticRenderFns } from "./UiFaq.vue?vue&type=template&id=7ccd7e24"
import script from "./UiFaq.vue?vue&type=script&lang=js"
export * from "./UiFaq.vue?vue&type=script&lang=js"
import style0 from "./UiFaq.vue?vue&type=style&index=0&id=7ccd7e24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports